import type { SiteConfig } from '../../@types/context/site-config.types';

export const contactAxoFiConfig: Pick<SiteConfig, 'contact'> = {
  contact: {
    phone: '09 4245 2326',
    email: 'asiakaspalvelu@axolaina.fi',
  },
};
